import React, { useEffect } from 'react';
// styles
import styled, { css } from 'styled-components';
// components
import SoFormHeader from './components/layout/SoFormHeader';
import SoFormFooter from './components/layout/SoFormFooter';
import SoFormBody from './components/layout/SoFormBody';
import { actions as orderActions } from 'state/order';
import { useDispatch } from 'react-redux';

const SoForm = ({ className }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(orderActions.checkPaymentMethod());
  }, [dispatch]);

  return (
    <div className={className}>
      <SoFormHeader />
      <SoFormBody />
      <SoFormFooter />
    </div>
  );
};

const regularCSS = css`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  background: var(--grey200);
`;

export default styled(SoForm)`
  ${regularCSS};
`;
